<template>
    <Container class="container-sm-none">
        <Card class="card-shadow mt-15 mt-md-0">
            <div class="width-lg">
                <div class="pl-10 pl-md-0 pr-10 pr-md-0">
                    <IconSadPerson />
                    <p class="heading-2 heading-md-1 weight-medium mt-20">
                        We're sorry, but the page you were looking for could not be found.
                    </p>
                    <p class="body-3 body-md-1 text-center weight-regular mt-10">
                      The page has been deleted, moved or renamed.
                    </p>
                    <p class="heading-3 mt-20 text-left">
                      What can you do now?
                    </p>
                    <ul class="text-left pl-8 weight-regular body-3 mt-10">
                        <li>
                          if you have entered the address manually in your browser, you can check it for typos
                        </li>
                        <li>
                          if you have copied & pasted the address, you can check if you have copied the whole address
                        </li>
                        <li>
                          if you have entered the address correctly or clicked on a link on the website,  <a class="color-primary" href="#">Contact Us</a>
                        </li>
                    </ul>
                    <div class="width-md mt-20">
                        <Button class="btn-primary w-full">
                            Go to Main Page
                        </Button>
                    </div>
                </div>
            </div>
        </Card>
    </Container>
</template>

<script>
import IconSadPerson from '@/components/Icons/IconSadPerson.vue';
import Container from '@/components/Container/Container.vue';
import Card from '@/components/Card/Card.vue';
import Button from '@/components/Button/Button.vue';

export default {
  name: 'NotFoundPage',
  components: {
    IconSadPerson,
    Container,
    Card,
    Button,
  },
  created() {
    this.model.step = 21;
    if (this.model.lastStep < 21) this.model.lastStep = 21;
  },
};
</script>
